import script from "./NewProductCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProductCatalog.vue?vue&type=script&setup=true&lang=js"

import "./NewProductCatalog.vue?vue&type=style&index=0&id=c9568642&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9568642"]])

export default __exports__